import React, {Component} from 'react';
import AdminProfileItem from './admin-home-profile-item';

class AdminHomeTableProfile extends Component{

    

    render(){

        return(
           <div className="tab-pane fade" id="profile" role="tabpanel">
               <div className="profile-tab-admin">
                        <AdminProfileItem userProfileName={"محمد يونس محمد "} userProfilePhoneNumber={"0112545484"} userProfileCompanyName={"CRETE Agency"} userProfileEmail={"crete@gmail.com"} userProfileCountry={"KSA"} userProfilePassword={"***************"} />
                     <div className="text-center">
                        <a className="get-start-btn light-btn red-btn" href="/home">تعديل بياناتك</a>
                     </div>
                </div>
            </div>
                        
            
        );
       
    }

};
export default AdminHomeTableProfile;


